var classes = {"container":"index-module_container__-QqoW","badgeAndShop":"index-module_badgeAndShop__IqKHq","phoneContainer":"index-module_phoneContainer__7-wKU"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
